import React from "react";
import config from "../../common/config";

export default (isAdminConsole) => {
  return isAdminConsole ? (
    <div className="error-container">
      <span style={{ fontSize: "xxx-large" }}>
        You do not have access to this page.
      </span>
      <div className="link-container">
        <a target="_blank" href={`${config.BASE_URL}`} className="more-link">
          Visit Nexus Home
        </a>
      </div>
    </div>
  ) : (
    <div className="error-container">
      <span style={{ fontSize: "xxx-large" }}>
        You do not have access to Nexus, Please contact Admin.
      </span>
    </div>
  );
};
